import axios from 'axios';
import { toast } from 'sonner';

const serverURL = 'https://quickview.rskgroupco.com/app';
const localURL = 'http://localhost:3001';
const ngrok = 'https://5e00-2803-9810-62e2-7810-253f-431b-33e6-791.ngrok-free.app';

const currentBaseURL = serverURL;

const apiClient = axios.create({
    baseURL: currentBaseURL, // baseURL comun para todos los endpoints
    headers: {
        'Content-Type': 'application/json'
    },
    timeout: 10000, // 10s timeout
});

// Cliente específico para exportador (sin interceptores automáticos)
const apiClientExporter = axios.create({
    baseURL: currentBaseURL,
    headers: {
        'Content-Type': 'application/json'
    },
    timeout: 10000,
});

// Interceptor de request para agregar el token automáticamente (solo para apiClient)
apiClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('authToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Interceptor de response para manejar errores de autenticación globalmente
apiClient.interceptors.response.use(
    response => response,
    error => {
        console.error('Error en la API:', error.response?.data || error.message);
        
        // Manejar solo 401 (token inválido o vencido)
        if (error.response?.status === 401) {
            // Limpiar token del localStorage
            localStorage.removeItem('authToken');
            
            // Mostrar mensaje elegante con toast
            toast.error('Tu sesión ha expirado. Por favor, inicia sesión nuevamente.', {
                duration: 5000,
                position: 'top-right',
            });
            
            // Redirigir al login después de un breve delay
            setTimeout(() => {
                window.location.href = '/login';
            }, 1000);
        }
        
        // Para 403 (sin permisos), solo mostrar mensaje pero NO desautenticar
        if (error.response?.status === 403) {
            toast.error('No tienes permisos para acceder a este recurso.', {
                duration: 4000,
                position: 'top-right',
            });
        }
        
        return Promise.reject(error);
    }
);

// Interceptor de request para agregar el token automáticamente (para apiClientExporter)
apiClientExporter.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('exporterAuthToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Interceptor de response para manejar errores de autenticación globalmente (para apiClientExporter)
apiClientExporter.interceptors.response.use(
    response => response,
    error => {
        console.error('Error en la API (Exporter):', error.response?.data || error.message);
        
        // Manejar solo 401 (token inválido o vencido)
        if (error.response?.status === 401) {
            // Limpiar token del localStorage
            localStorage.removeItem('exporterAuthToken');
            
            // Mostrar mensaje elegante con toast
            toast.error('Tu sesión ha expirado. Por favor, inicia sesión nuevamente.', {
                duration: 5000,
                position: 'top-right',
            });
            
            // Redirigir al login después de un breve delay
            setTimeout(() => {
                window.location.href = '/exporter';
            }, 1000);
        }
        
        // Para 403 (sin permisos), solo mostrar mensaje pero NO desautenticar
        if (error.response?.status === 403) {
            toast.error('No tienes permisos para acceder a este recurso.', {
                duration: 4000,
                position: 'top-right',
            });
        }
        
        return Promise.reject(error);
    }
);

export { apiClient, apiClientExporter, currentBaseURL };